module.exports = __webpack_public_path__ + "img/refused.c954db4.png";